export const base = {
  fileUrl: '/aws-files/',
  localStorageEncrptKey: '287e148b-921f-4d4e-b355-b56b5e8304aa',
};
